import * as actions1 from './actions'
import * as actions2 from './modulesActions'
import * as actions3 from './faqActions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'

const actions = {
  ...actions1,
  ...actions2,
  ...actions3
};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
